import {
  CbexMomentExam,
  CbexPortalCandidatesByMomentIdRow,
  PlanningActivityType,
} from "@cbex/data-access";
import dayjs from "dayjs";

export const getExamEditState = (input: CbexMomentExam): boolean => {
  const today = dayjs();
  const hourDiff = dayjs(input.moment.startDate).diff(today, "minutes");
  const candidateMutationAllowedMinutes =
    input.activities[0]?.activityType?.settings
      ?.candidateMutationAllowedMinutes;

  return candidateMutationAllowedMinutes
    ? hourDiff >= candidateMutationAllowedMinutes
    : hourDiff >= 0;
};

export const getCandidatesImmutable = (
  allActivities: PlanningActivityType[],
  allCandidates: CbexPortalCandidatesByMomentIdRow[],
  momentStartDate: string
) =>
  allCandidates.filter(
    (candidate) =>
      dayjs(momentStartDate).isBefore(dayjs()) ||
      getActivitiesImmutable(allActivities, momentStartDate, true).some(
        (activity) => activity.activityTypeID === candidate.activityTypeID
      )
  );

export const getActivitiesImmutable = (
  allActivities: PlanningActivityType[],
  momentStartDate: string,
  forCandidates?: boolean
) =>
  allActivities.filter(
    (activity) =>
      dayjs(momentStartDate).isBefore(dayjs()) ||
      dayjs(momentStartDate).diff(dayjs(), "minutes") <
        (forCandidates
          ? activity?.settings?.candidateMutationAllowedMinutes
          : activity?.settings?.activityMutationAllowedMinutes)
  );

export const getActivitiesCreationNotAllowed = (
  allActivities: PlanningActivityType[],
  momentStartDate: string,
  isEdit?: boolean
) =>
  allActivities.filter(
    (activity) =>
      dayjs(momentStartDate).isBefore(dayjs()) ||
      dayjs(momentStartDate).diff(dayjs(), "minutes") <
        (!isEdit
          ? activity?.settings?.allowNewExamMinutes
          : activity?.settings?.candidateMutationAllowedMinutes)
  );
